module.exports = __webpack_public_path__ + "img/Flag_of_Italy.48651b91.svg";